import React, { useContext, useEffect } from "react";
import AppRoutes from "../Routes/Routes";
import { AuthContext } from "../Context/AuthContext";
import NotificationToast from "../Components/Common/NotificationToast/NotificationToast";
import { useLocation, useNavigate } from "react-router-dom";
import { setAuthToken } from "../RestApi/tokenUtils";
import { isObjectEmpty } from "../Utils/utils";
import DuplicateContactsContextProvider from "../Context/DuplicateContactsContext";
import UnverifiedContactsContextProvider from "../Context/UnverifiedContactContext";
import { prefetchAfterLoginIdle } from "../Utils/routePrefetch";

const Layouts = ({ children }) => {
  const { userData, authUser } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    if (token && !location.pathname.includes("/reset/password")) {
      setAuthToken(token);
      authUser();
      // Remove query param from URL
      navigate(location.pathname, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    if (userData?.authenticated) {
      prefetchAfterLoginIdle();
    }
  }, [userData?.authenticated]);

  const content = (
    <React.Fragment>
      <AppRoutes />
      <NotificationToast
        variant="success"
        position={"top-end"}
        toastPosition={"top-end"}
        autoHide={true}
        delay={500000}
      />
    </React.Fragment>
  );

  if (userData?.authenticated) {
    return (
      <DuplicateContactsContextProvider>
        <UnverifiedContactsContextProvider>{content}</UnverifiedContactsContextProvider>
      </DuplicateContactsContextProvider>
    );
  }

  return content;
};

export default Layouts;
